// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"355":"d056af45","453":"b4f5330d","633":"91e90623"}[chunkId] + ".chunk.js";
};